import React from 'react';

class AnswerOption extends React.Component {
  constructor() {
    super();
    this.state = {
      otherValue: "",
    }
  }

  onClickHandler = (target) => {    
    const {field, value} = this.props;
    this.props.onChangeHandler(field, value, this.state.otherValue, null, []);
  }

  onChangeOtherValue = (e) => {
    const {value} = e.target
    this.setState({
      otherValue:value
    });
    const field = this.props.field;
    const optionValue = this.props.value;
    this.props.onChangeHandler(field, optionValue, this.state.otherValue, null, []);
  }

  getInput = (field, id, value, isChecked) => {
    if(isChecked){
      return <input className="form-check-input"   
                  type="radio" 
                  name={field} 
                  id={id} 
                  value={value}
                  defaultChecked
                  />
    }
    return <input className="form-check-input"   
                  type="radio" 
                  name={field} 
                  id={id} 
                  value={value}
                  />
  }

  render() {
    const {field, text, value, isChecked, keyIdentifier} = this.props;
    const inputElement = this.getInput(field,`${field}${keyIdentifier}`, value, isChecked);
    if(value !== "Otro"){
      return (
            <div className="option" onClick={this.onClickHandler}>
                {inputElement}
                <label className="form-check-label" 
                  htmlFor={`${field}${keyIdentifier}`}>
                    {text}
                </label>
            </div>
          
      );
    }
    return (
      <div className="option" onClick={this.onClickHandler}>
          {inputElement}
          <label className="form-check-label" htmlFor={`${field}${keyIdentifier}`}>
              {text}
          </label>
          <input type="text" 
            name={`${field}-otherValue`}
            onChange={this.onChangeOtherValue} 
          />
      </div>
    );
  }
}

export default AnswerOption;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/AnswerOption.js